import {subtract} from 'stringdate';
import {useCountry} from '~/feature/country/CountryContext';
import useDatePickerMinAndMaxDates from './useDatePickerMinAndMaxDates';

export default function useEarliestSelectableCreativeDate(options?: {
    type: 'spend' | 'creative' | 'compliance';
}) {
    const type = options?.type ?? 'creative';
    const {isCreativeOnTrial, isComplianceOnTrial} = useCountry();
    const {maxValue, minValue} = useDatePickerMinAndMaxDates(
        type === 'spend' ? {type: 'spend'} : {type}
    );

    const isTrialing =
        (type === 'creative' && isCreativeOnTrial) ||
        (type === 'compliance' && isComplianceOnTrial);

    return isTrialing ? subtract('P1M')(maxValue) : minValue;
}
